import React, { useEffect, useState } from 'react'
import { Row, Spin, Empty } from 'antd'
import moment from 'moment'
import _ from 'lodash'
import serviceInterface from '../../services/service.interface'
import ZoomableImage from '../zoom/zoom.image'

const WoundImages = ({ patient }) => {
  const [images, setImages] = useState([])
  const [loading, setLoading] = useState(false)
  const [zoomSrc, setZoomSrc] = useState('')
  const [zoomOpen, setZoomOpen] = useState(false)

  useEffect(() => {
    if (patient && patient._id) fetchImages(patient._id)
  }, [patient && patient._id])

  const fetchImages = (patientid) => {
    setLoading(true)
    serviceInterface
      .PatientService()
      .getWoundImages(patientid)
      .then((res) => {
        setLoading(false)
        if (res && res.images) setImages(res.images)
      })
      .catch((err) => {
        setLoading(false)
        console.log(err, 'Error fetching wound images')
      })
  }

  const handleView = (original) => {
    if (!original) return
    serviceInterface
      .ActioncaseService()
      .getImageUrl({ fileName: original, type: 'wound' })
      .then((data) => {
        if (data && data.imageUrl) {
          setZoomSrc(data.imageUrl)
          setZoomOpen(true)
        }
      })
      .catch((err) => console.log(err, 'Error viewing wound image'))
  }

  if (loading) {
    return (
      <Row justify='center' style={{ padding: 24 }}>
        <Spin />
      </Row>
    )
  }

  if (_.isEmpty(images)) {
    return (
      <Empty description='No wound images sent by this patient yet.' />
    )
  }

  return (
    <>
      <div className='wound-images-grid'>
        {images.map((img) => (
          <div className='wound-image-card' key={img._id}>
            <img
              src={img.imageUrl && img.imageUrl.thumbnail}
              alt='wound'
              onClick={() => handleView(img.imageUrl && img.imageUrl.original)}
            />
            <span className='wound-image-date'>
              {moment(img.createdDate).format('MMM D, YYYY h:mm A')}
            </span>
          </div>
        ))}
      </div>
      <ZoomableImage
        src={zoomSrc}
        open={zoomOpen}
        onClose={() => setZoomOpen(false)}
      />
    </>
  )
}

export default WoundImages
